import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  addIconGallery,
  chakMarkWhite,
  checkMarkOrange,
  closeIcon,
  deleteIconBlue,
  deleteIconCircleOrange,
  eyeClose,
  gallery1,
  gallery10,
  gallery11,
  gallery12,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  menuDotsIcon,
  modalCloseIcon,
  moveIocn,
  pinIocn,
} from "../../../../../images";
import Modal from "react-bootstrap/Modal";
import "./galleryPopupComn.scss";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import GalleryPopupRecentlyDeleted from "./GalleryPopupRecentlyDeleted";
import BottomSheetOptions from "./BottomSheetOptions";
import { useWindowSize } from "react-use";
import GalleryPopupMove from "./GalleryPopupMove";
import config from "../../../../../config/config";

const LongPressGalleryPopup = forwardRef((props, ref) => {
  // const images = [
  //   gallery1,
  //   gallery2,
  //   gallery3,
  //   gallery4,
  //   gallery5,
  //   gallery6,
  //   gallery7,
  //   gallery8,
  //   gallery9,
  //   gallery10,
  //   gallery11,
  //   gallery12,
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/951076/pexels-photo-951076.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   // "https://images.pexels.com/photos/951076/pexels-photo-951076.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   // "https://images.pexels.com/photos/15568759/pexels-photo-15568759/free-photo-of-bird-among-spring-blossoms-on-tree.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31314773/pexels-photo-31314773/free-photo-of-homemade-baking-in-a-traditional-mexican-kitchen.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31314773/pexels-photo-31314773/free-photo-of-homemade-baking-in-a-traditional-mexican-kitchen.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/20257362/pexels-photo-20257362/free-photo-of-back-view-of-a-deer-with-antlers-in-a-forest.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31087915/pexels-photo-31087915/free-photo-of-lush-green-terraced-rice-fields-in-mountainous-landscape.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   // gallery1,
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // gallery3,
  //   // gallery4,
  //   // gallery1,
  //   // gallery7,
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  // ];
  const { width } = useWindowSize();
  const suppressClickRef = useRef(false);

  const [columns, setColumns] = useState(4); // Default: 4 columns
  const [showMovePopup, setShowMovePopup] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
    useState(false);
  const [showGallerypopupRecentlyDeleted, setShowGallerypopupRecentlyDeleted] =
    useState(false);
  const [checkedItems, setCheckedItems] = useState({});

  const [selectionMode, setSelectionMode] = useState(false);
  const timerRef = useRef(null);

  const aws_object_url = config.aws_object_url;

  const handleCheckboxToggle = (key, item) => {
    setSelectedImages((prev) => {
      if (checkedItems[key]) {
        return prev.filter((selected) => selected.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // NEW: Long press functionality
//   const handleLongPressStart = (itemKey, item) => {
//     timerRef.current = setTimeout(() => {
//       setSelectionMode(true);
//       // Auto-select the long-pressed item
//       if (!checkedItems[itemKey]) {
//         handleCheckboxToggle(itemKey, item);
//       }
//     }, 900); // 2 seconds as requested
//   };

const handleLongPressStart = (itemKey, item) => {
  timerRef.current = setTimeout(() => {
    setSelectionMode(true);
    suppressClickRef.current = true; // suppress next click

    // Always select the long-pressed item
    setSelectedImages((prev) => {
      if (prev.some((selected) => selected.id === item.id)) {
        return prev;
      }
      return [...prev, item];
    });

    setCheckedItems((prev) => ({
      ...prev,
      [itemKey]: true,
    }));
  }, 900);
};


  const clearLongPress = () => {
    clearTimeout(timerRef.current);
  };

//   const handleImageInteraction = (itemKey, item) => {
//     if (selectionMode) {
//       // If already in selection mode, toggle selection
//       handleCheckboxToggle(itemKey, item);
//     }
//     // If not in selection mode, do nothing (let long press handle it)
//   };

const handleImageInteraction = (itemKey, item) => {
  if (suppressClickRef.current) {
    suppressClickRef.current = false; // reset after skipping one click
    return;
  }

  if (selectionMode) {
    handleCheckboxToggle(itemKey, item);
  }
};


  // NEW: Function to exit selection mode
  const exitSelectionMode = () => {
    setSelectionMode(false);
    setSelectedImages([]);
    setCheckedItems({});
  };

  const selectedCount = Object.values(checkedItems).filter(Boolean).length;

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(4);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  // Find this function (around line 150-156)
  useImperativeHandle(ref, () => ({
    handleShowDeletePopupClose,
    resetCheckedItems: () => {
      setSelectedImages([]);
      setCheckedItems({});
      setSelectionMode(false); // ADD this line
    },
  }));

  // Masonry logic: Arranging images row-wise instead of column-wise
  const createMasonryLayout = () => {
    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);
    const filteredImages =
      props?.categoryData?.data?.[props?.categoryData?.category?.key];

    filteredImages?.forEach((img) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights)
      );
      arranged[shortestColumnIndex].push({
        src: `${aws_object_url}business/${img?.url}`,
        id: img._id,
        section: props?.categoryData?.category?.key,
        name: img?.url,
      });
      columnHeights[shortestColumnIndex] += 1; // Assuming equal height for each image
    });

    return arranged;
  };

  const arrangedImages = createMasonryLayout();
  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const handleShowDeletePopupOpen = () => {
    setShowDeletePopup(true);
  };
  const handleShowDeletePopupClose = () => {
    // setSelectedImages([]);
    // setCheckedItems({});
    setShowDeletePopup(false);
  };
  const handleRecentlyDeletedPopupOpen = () =>
    setShowGallerypopupRecentlyDeleted(true);
  const handleRecentlyDeletedPopupClose = () =>
    setShowGallerypopupRecentlyDeleted(false);

  const handleGallerypopupDeleteVariantOpen = () =>
    setShowGallerypopupDeleteVariant(true);
  const handleGallerypopupDeleteVariantClose = () =>
    setShowGallerypopupDeleteVariant(false);
  const handleGallerypopupMoveOpen = () => setShowMovePopup(true);
  const handleGallerypopupMoveClose = () => setShowMovePopup(false);
//   const handleDeleteImages = (data) => props.onDeleteImages(data);

  const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupClose = () => setShowOptionsPopup(false);
  useImperativeHandle(ref, () => ({
    handleShowDeletePopupClose,
    resetCheckedItems: () => {
      setSelectedImages([]);
      setCheckedItems({});
    },
  }));
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {width <= 768 && (
        <BottomSheetOptions
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={handleGallerypopupDeleteVariantOpen}
          handelOpenMove={handleGallerypopupMoveOpen}
          handelOpenRecentlyDeleted={handleRecentlyDeletedPopupOpen}
        />
      )}

      <DeleteConfirmPopup
        show={showDeletePopup}
        handleClose={handleShowDeletePopupClose}
        headingSugested={"Add More Project Photos & Renders"}
        data={selectedImages}
        deleteImages={()=>{}}
      />
      <GalleryPopupMove
        show={showMovePopup}
        handleCloseDelete={handleGallerypopupMoveClose}
      />
      <GalleryPopupRecentlyDeleted
        show={showGallerypopupRecentlyDeleted}
        handleCloseDelete={handleRecentlyDeletedPopupClose}
        selectedCount={selectedCount}
      />
      <Modal
        {...props}
        centered
        className="Gallery_popup_modal gallery_popup_edit"
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button
            className="custom-cancel-btn"
            onClick={() => {
              setCheckedItems({});
              setSelectedImages([]);
              setSelectionMode(false); //
              props.handleClose();
            }}
          >
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Gallery_popup_heading d-flex align-items-center">
            Delete {props?.categoryData?.category?.title}
            {/* <div
              className="menu-wrapper"
              ref={menuRef}
              onClick={() => setIsHovered(!isHovered)}
            >
              <div className="three-dot-icon">
                <img
                  src={menuDotsIcon}
                  alt="menu"
                  className="menu_gallery_popup_edit_icon"
                  onClick={handleOptionsPopupOpen}
                />
              </div>
              <div className={`hover-menu ${isHovered ? "show" : "hide"}`}>
                <div className="menu-item">
                  <img
                    src={deleteIconCircleOrange}
                    alt=""
                    className="menu_icon_popup"
                  />{" "}
                  Delete Images
                </div>

                <div className="menu-item">
                  <img src={eyeClose} alt="" className="menu_icon_popup" /> Hide
                  Images
                </div>
                <div className="menu-item">
                  <img src={pinIocn} alt="" className="menu_icon_popup" /> Pin
                  Images
                </div>

                <div className="menu-item">
                  <img src={moveIocn} alt="" className="menu_icon_popup" /> Move
                  Images
                </div>
                <div
                  className="menu-item border-0"
                  onClick={handleRecentlyDeletedPopupOpen}
                >
                  Recently Deleted
                </div>
              </div>
            </div> */}
          </h2>

          <h3 className="popup_muted_title">{selectedCount} images selected</h3>
          {/* {selectionMode || selectedCount > 0
            ? `${selectedCount} images selected`
            : ""} */}

          {selectionMode && (
            <div
              style={{
                marginBottom: "15px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <button
                onClick={exitSelectionMode}
                style={{
                  background: "transparent",
                  border: "1px solid #000000",
                  borderRadius: "20px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  color: "#000000",
                  marginLeft:"3rem"
                }}
              >
                Cancel Selection
              </button>
              <span style={{ color: "#000000", fontSize: "16px" }}>
                Tap images to select/deselect
              </span>
            </div>
          )}

     <div className="masonry-gallery-two">
  {arrangedImages.map((column, colIndex) => (
    <div className="masonry-column" key={colIndex}>
      {column.map((item, index) => {
        const itemKey = `${colIndex}-${index}`;
        const isChecked = checkedItems[itemKey];

        return (
          <div
            className="masonry-item position-relative"
            key={itemKey}
            style={{ userSelect: "none" }}
            onContextMenu={(e) => e.preventDefault()}
          >
            <img
              src={item.src}
              alt={`Gallery ${index}`}
              loading="lazy"
              style={{
                display: "block",
                pointerEvents: "none",
                userSelect: "none",
                WebkitUserSelect: "none",
                WebkitUserDrag: "none",
              }}
              draggable={false}
            />

            {/* ✅ SINGLE corrected overlay */}
            <div
              onMouseDown={() => handleLongPressStart(itemKey, item)}
              onTouchStart={() => handleLongPressStart(itemKey, item)}
              onContextMenu={(e) => e.preventDefault()}
              onMouseUp={clearLongPress}
              onTouchEnd={clearLongPress}
              onMouseLeave={clearLongPress}
              onClick={() => handleImageInteraction(itemKey, item)}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 5,
                backgroundColor: "rgba(255,255,255,0.01)", // NOT fully transparent
                touchAction: "manipulation",
                userSelect: "none",
                WebkitUserSelect: "none",
                cursor: "pointer",
              }}
            />

            {/* Checkbox UI */}
            {selectionMode && (
              <div
                onClick={() => handleCheckboxToggle(itemKey, item)}
                className={`${
                  isChecked
                    ? "checked check_box_ctm_popup_wraper"
                    : "check_box_ctm_popup_wraper"
                }`}
                style={{ zIndex: 10 }}
              >
                <input
                  type="checkbox"
                  checked={isChecked || false}
                  onChange={() => {}}
                  className="hiden_ip_ctm_popup"
                />
                {isChecked && (
                  <img
                    src={chakMarkWhite}
                    alt="Checkmark"
                    className="chek_mark_ctm_popup"
                  />
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  ))}
</div>


          {selectedCount > 0 && (
            <div
              className="delete_gallery_image"
              onClick={handleShowDeletePopupOpen}  style={{ zIndex: 9999999 }}
            >
              <button className="delete_wrapper"   style={{ zIndex: 9999999 }}>
                <img
                  src={deleteIconBlue}
                  alt="delete"
                  className="delete_icon"
                />
                Delete {selectedCount} Images
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
});

export default LongPressGalleryPopup;
